import React from 'react';
import { Droplet } from 'react-feather';

const ColorPicker = ({ selectedColor, onColorChange, disabled = false }) => {
    const handleColorChange = (event) => {
        onColorChange(event.target.value);
    };

    return (
        <div className="d-flex align-items-center">
            <div 
                style={{ 
                    width: '20px', 
                    height: '20px', 
                    backgroundColor: selectedColor, 
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    marginRight: '8px'
                }}
            />
            <input
                type="color"
                value={selectedColor}
                onChange={handleColorChange}
                disabled={disabled}
                style={{
                    width: '40px',
                    height: '32px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    opacity: disabled ? 0.6 : 1
                }}
                title="Select text color"
            />
            <Droplet 
                size={16} 
                style={{ 
                    marginLeft: '6px',
                    color: disabled ? '#6c757d' : '#495057'
                }} 
            />
        </div>
    );
};

export default ColorPicker;
